<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="container-fluid">
                        <p class="componentTitle">Energy Leadership</p>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <div>
                                    <i (click)="previusContent()" class="material-icons">arrow_back</i>
                                    <i (click)="nextContent()" class="material-icons">arrow_forward</i>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <label>See: </label>
                                <select [(ngModel)]="currentActive" #active (change)="changeContentActive($event, active.value)" class="input">
                                    <option *ngFor="let option of options; let i = index;" id="{{i}}" value="{{i}}">{{option.title}}</option>
                                </select>
                            </div>
                        </div>

                        <ng-container *ngFor="let option of options; let i= index;">
                            <ng-container *ngIf="option.active">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h4>{{option.title}}</h4>
                                        <p>{{option.content}}</p>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                    </div>
                    <br />
                </div>
            </div>
        </div>
    </div>
</div>
